import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVolume = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 19,
	viewBox: "0 0 20 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M17.0569 14.5946C16.6427 14.8367 16.1191 14.682 15.8874 14.2489C15.6558 13.8158 15.8038 13.2684 16.218 13.0262C17.3881 12.3422 18.1277 11.052 18.1277 9.62536C18.1277 8.20923 17.399 6.92713 16.2426 6.23897C15.8301 5.9935 15.6861 5.44494 15.9209 5.01371C16.1557 4.58249 16.6804 4.4319 17.0929 4.67736C18.7809 5.68189 19.8464 7.55675 19.8464 9.62536C19.8464 11.7094 18.7649 13.596 17.0569 14.5946Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.38285 14.4169L2.49592 13.6042C1.42474 13.3802 0.653687 12.3969 0.653687 11.2549V7.99559C0.653687 6.85354 1.42474 5.87026 2.49592 5.64628L6.38285 4.83356L10.156 0.888948C10.6034 0.421132 11.3289 0.421132 11.7764 0.888948C11.9913 1.1136 12.112 1.4183 12.112 1.736V17.5145C12.112 18.176 11.599 18.7124 10.9662 18.7124C10.6623 18.7124 10.3708 18.5862 10.156 18.3615L6.38285 14.4169Z",
		fill: "white"
	})]
});
export default SvgVolume;
